export const SET_TICKET = 'TICKET/SET_TICKET'
export const SET_TICKETS = 'TICKET/SET_TICKETS'
